import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

// Import components
import VideoTestimonialCard from './components/VideoTestimonialCard';
import WrittenReviewCard from './components/WrittenReviewCard';
import MonthlyChampionsSection from './components/MonthlyChampionsSection';
import SuccessMetricsSection from './components/SuccessMetricsSection';
import SocialProofSection from './components/SocialProofSection';
import VideoModal from './components/VideoModal';

const SuccessStoriesGallery = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');

  // Mock video testimonials data
  const videoTestimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      city: "Mumbai",
      state: "Maharashtra",
      winAmount: 2500000,
      game: "Royal Roulette",
      thumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop&crop=face",
      duration: "3:45",
      quote: "Nitin\'s WhatsApp support guided me through every step. The payout was instant and the experience was incredible!",
      date: "15th August 2025",
      views: 12500,
      category: "big-win"
    },
    {
      id: 2,
      name: "Priya Sharma",
      city: "Delhi",
      state: "Delhi",
      winAmount: 850000,
      game: "Teen Patti Gold",
      thumbnail: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=600&h=400&fit=crop&crop=face",
      duration: "2:30",
      quote: "Started with ₹10,000 and won ₹8.5 lakhs! The customer service through WhatsApp is outstanding.",
      date: "12th August 2025",
      views: 8900,
      category: "regular-win"
    },
    {
      id: 3,
      name: "Amit Patel",
      city: "Ahmedabad",
      state: "Gujarat",
      winAmount: 1200000,
      game: "Andar Bahar Pro",
      thumbnail: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=600&h=400&fit=crop&crop=face",
      duration: "4:15",
      quote: "The platform is completely trustworthy. Multiple wins and always paid on time. Highly recommended!",
      date: "10th August 2025",
      views: 15200,
      category: "regular-win"
    },
    {
      id: 4,
      name: "Kavya Reddy",
      city: "Hyderabad",
      state: "Telangana",
      winAmount: 650000,
      game: "Dragon Tiger",
      thumbnail: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&h=400&fit=crop&crop=face",
      duration: "3:20",
      quote: "As a first-time player, the WhatsApp support team made me feel comfortable and confident.",
      date: "8th August 2025",
      views: 6700,
      category: "first-time"
    },
    {
      id: 5,
      name: "Vikash Singh",
      city: "Pune",
      state: "Maharashtra",
      winAmount: 3200000,
      game: "Baccarat VIP",
      thumbnail: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&h=400&fit=crop&crop=face",
      duration: "5:10",
      quote: "Biggest win of my life! ₹32 lakhs in a single game. Nitin is the most reliable platform in India.",
      date: "5th August 2025",
      views: 25400,
      category: "big-win"
    },
    {
      id: 6,
      name: "Sneha Joshi",
      city: "Bangalore",
      state: "Karnataka",
      winAmount: 420000,
      game: "Blackjack Pro",
      thumbnail: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&h=400&fit=crop&crop=face",
      duration: "2:45",
      quote: "The mobile experience is fantastic. Won ₹4.2 lakhs while traveling. Instant payout to my account!",
      date: "3rd August 2025",
      views: 5800,
      category: "regular-win"
    }
  ];

  // Mock written reviews data
  const writtenReviews = [
    {
      id: 1,
      name: "Arjun Reddy",
      location: "Chennai, Tamil Nadu",
      platform: "google",
      rating: 5,
      date: "2 days ago",
      content: "Excellent platform with genuine payouts. Won ₹75,000 last week and received payment within 20 minutes. Customer service through WhatsApp is outstanding! The team is very professional and helpful.",
      highlights: ["Fast Payout", "WhatsApp Support", "Trustworthy"],
      likes: 24
    },
    {
      id: 2,
      name: "Meera Gupta",
      location: "Jaipur, Rajasthan",
      platform: "facebook",
      rating: 5,
      date: "5 days ago",
      content: "Been playing for 6 months now. Multiple wins, always paid on time. The WhatsApp support team is very helpful and professional. They guide you through every step. Highly recommended for serious players!",
      highlights: ["Reliable", "Professional Support", "Multiple Wins"],
      likes: 18
    },
    {
      id: 3,
      name: "Manoj Kumar",
      location: "Lucknow, Uttar Pradesh",
      platform: "google",
      rating: 5,
      date: "1 week ago",
      content: "Started with ₹5000, now I've won over ₹2 lakhs! The platform is completely trustworthy. Love the instant WhatsApp support feature. They're available 24/7 and always ready to help.",
      highlights: ["Big Wins", "24/7 Support", "Trustworthy"],
      likes: 31
    },
    {
      id: 4,
      name: "Ritu Sharma",
      location: "Chandigarh, Punjab",
      platform: "facebook",
      rating: 5,
      date: "1 week ago",
      content: "As a woman player, I was initially hesitant. But the customer service team made me feel comfortable and secure. Won ₹45,000 in my first month. The payout process is very smooth and transparent.",
      highlights: ["Secure Platform", "Smooth Payouts", "Beginner Friendly"],
      likes: 22
    },
    {
      id: 5,
      name: "Deepak Agarwal",
      location: "Indore, Madhya Pradesh",
      platform: "google",
      rating: 5,
      date: "2 weeks ago",
      content: "The variety of games is impressive. Won big in Teen Patti and Andar Bahar. The WhatsApp customer support is the best feature - instant responses and very knowledgeable team members.",
      highlights: ["Game Variety", "Instant Support", "Knowledgeable Team"],
      likes: 27
    },
    {
      id: 6,
      name: "Pooja Malhotra",
      location: "Gurgaon, Haryana",
      platform: "facebook",
      rating: 5,
      date: "2 weeks ago",
      content: "Mobile gaming experience is excellent. The app is smooth and user-friendly. Won ₹85,000 last month and the money was in my account within 15 minutes. Outstanding service!",
      highlights: ["Mobile Experience", "Fast Payouts", "User Friendly"],
      likes: 19
    }
  ];

  const filterOptions = [
    { id: 'all', name: 'All Stories', icon: 'Trophy' },
    { id: 'big-win', name: 'Big Wins', icon: 'Crown' },
    { id: 'regular-win', name: 'Regular Wins', icon: 'Target' },
    { id: 'first-time', name: 'First-Time Winners', icon: 'Star' }
  ];

  const filteredTestimonials = activeFilter === 'all' 
    ? videoTestimonials 
    : videoTestimonials?.filter(testimonial => testimonial?.category === activeFilter);

  const handleVideoPlay = (testimonial) => {
    setSelectedVideo(testimonial);
    setIsVideoModalOpen(true);
  };

  const handleCloseVideoModal = () => {
    setIsVideoModalOpen(false);
    setSelectedVideo(null);
  };

  const handleWhatsAppContact = () => {
    const message = "Hi! I've seen the amazing success stories and I want to start my winning journey with Nitin Online Hub. Can you help me get started?";
    window.open(`https://wa.me/917704070169?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Success Stories Gallery - Winner Showcase | Nitin Online Hub | Nitin Online Book</title>
        <meta name="description" content="Discover inspiring success stories from Nitin Online Hub and Nitin Online Book winners. Watch video testimonials, read reviews, and see how our players achieved their gaming dreams with trusted WhatsApp support and Nitin online book platform." />
        <meta name="keywords" content="Nitin Online Hub winners, Nitin Online Book success stories, gaming testimonials, online casino winners, Indian gaming platform, WhatsApp support, player reviews, Nitin online book winners, Nitin betting success" />
        <meta property="og:title" content="Success Stories Gallery - Winner Showcase | Nitin Online Hub | Nitin Online Book" />
        <meta property="og:description" content="Discover inspiring success stories from Nitin Online Hub and Nitin Online Book winners. Watch video testimonials, read reviews, and see how our players achieved their gaming dreams with trusted WhatsApp support." />
        <meta property="og:image" content="https://nitinonlinehub.in/assets/images/logo.png" />
        <meta property="og:url" content="https://nitinonlinehub.in/success-stories-gallery-winner-showcase" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Nitin Online Hub" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Success Stories Gallery - Winner Showcase | Nitin Online Hub | Nitin Online Book" />
        <meta name="twitter:description" content="Discover inspiring success stories from Nitin Online Hub and Nitin Online Book winners. Watch video testimonials, read reviews, and see how our players achieved their gaming dreams with trusted WhatsApp support." />
        <meta name="twitter:image" content="https://nitinonlinehub.in/assets/images/logo.png" />
        <link rel="canonical" href="https://nitinonlinehub.in/success-stories-gallery-winner-showcase" />

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://nitinonlinehub.in/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Success Stories",
                  "item": "https://nitinonlinehub.in/success-stories-gallery-winner-showcase"
                }
              ]
            }
          `}
        </script>
        <meta property="og:title" content="Success Stories Gallery - Winner Showcase | Nitin Online Hub" />
        <meta property="og:description" content="Real winners, real stories. See how Nitin Online Hub players achieved success with our trusted gaming platform and exceptional WhatsApp customer service." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://nitinonlinehub.in/success-stories-gallery-winner-showcase" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        {/* Hero Section */}
        <section className="py-16 bg-gradient-royal text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <Icon name="Trophy" size={48} color="white" />
              <h1 className="text-4xl md:text-6xl font-heading font-bold">
                Success Stories Gallery
              </h1>
            </div>
            <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto mb-8">
              Real Winners, Real Stories, Real Success with Nitin Online Hub
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                size="lg"
                onClick={handleWhatsAppContact}
                iconName="MessageCircle"
                iconPosition="left"
                className="bg-white text-primary hover:bg-gray-100"
              >
                Start Your Success Story
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => document.getElementById('video-testimonials')?.scrollIntoView({ behavior: 'smooth' })}
                iconName="Play"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10"
              >
                Watch Success Stories
              </Button>
            </div>
          </div>
        </section>

        {/* Success Metrics Section */}
        <SuccessMetricsSection />

        {/* Video Testimonials Section */}
        <section id="video-testimonials" className="py-16 bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Header */}
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-gradient-royal mb-4">
                Video Success Stories
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                Watch authentic testimonials from our winners sharing their incredible gaming journey
              </p>
            </div>

            {/* Filter Tabs */}
            <div className="flex flex-wrap justify-center gap-2 mb-12">
              {filterOptions?.map((filter) => (
                <button
                  key={filter?.id}
                  onClick={() => setActiveFilter(filter?.id)}
                  className={`flex items-center space-x-2 px-6 py-3 rounded-button text-sm font-medium transition-royal ${
                    activeFilter === filter?.id
                      ? 'bg-primary text-primary-foreground shadow-royal'
                      : 'bg-card text-text-secondary hover:text-primary hover:bg-muted border border-border'
                  }`}
                >
                  <Icon name={filter?.icon} size={16} />
                  <span>{filter?.name}</span>
                </button>
              ))}
            </div>

            {/* Video Testimonials Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredTestimonials?.map((testimonial) => (
                <VideoTestimonialCard
                  key={testimonial?.id}
                  testimonial={testimonial}
                  onPlay={handleVideoPlay}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Monthly Champions Section */}
        <MonthlyChampionsSection />

        {/* Written Reviews Section */}
        <section className="py-16 bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Header */}
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-gradient-royal mb-4">
                Player Reviews & Testimonials
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                Read detailed reviews from our satisfied players across India
              </p>
            </div>

            {/* Written Reviews Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {writtenReviews?.map((review) => (
                <WrittenReviewCard key={review?.id} review={review} />
              ))}
            </div>
          </div>
        </section>

        {/* Social Proof Section */}
        <SocialProofSection />

        {/* Final CTA Section */}
        <section className="py-16 bg-gradient-royal text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <Icon name="Sparkles" size={32} color="white" />
              <h2 className="text-3xl md:text-4xl font-heading font-bold">
                Your Success Story Awaits
              </h2>
            </div>
            <p className="text-xl opacity-90 mb-8">
              Join thousands of winners who chose Nitin Online Hub for their gaming success. 
              Start your journey today with personalized WhatsApp support.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                size="lg"
                onClick={handleWhatsAppContact}
                iconName="MessageCircle"
                iconPosition="left"
                className="bg-white text-primary hover:bg-gray-100 whatsapp-pulse"
              >
                Chat with Gaming Expert
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => window.open('tel:+917704070169', '_self')}
                iconName="Phone"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10"
              >
                Call Now: +91 98765 43210
              </Button>
            </div>

            <div className="mt-8 flex items-center justify-center space-x-8 text-sm opacity-80">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} />
                <span>100% Secure</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} />
                <span>24/7 Support</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Zap" size={16} />
                <span>Instant Payouts</span>
              </div>
            </div>
          </div>
        </section>

        {/* Video Modal */}
        <VideoModal
          isOpen={isVideoModalOpen}
          onClose={handleCloseVideoModal}
          testimonial={selectedVideo}
        />

        {/* Floating WhatsApp Button */}
        <div className="fixed bottom-6 right-6 z-40">
          <button
            onClick={handleWhatsAppContact}
            className="w-14 h-14 bg-success hover:bg-success/90 rounded-full shadow-royal flex items-center justify-center transition-royal whatsapp-pulse"
            aria-label="Contact via WhatsApp"
          >
            <Icon name="MessageCircle" size={24} color="white" />
          </button>
        </div>
      </div>
    </>
  );
};

export default SuccessStoriesGallery;